import { render } from "./LineWithDataLabelsChart.vue?vue&type=template&id=d54a4d64&ts=true"
import script from "./LineWithDataLabelsChart.vue?vue&type=script&lang=ts"
export * from "./LineWithDataLabelsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__